import { API_ORIGIN } from '@/lib/config'
import type { Role } from '@/types/api'
import { PLATFORM_LABELS } from '@/lib/platform-labels'
import { i18n } from '@/lib/i18n'

/** Tên vai trò gốc theo ngôn ngữ đang dùng (getter đọc i18n lúc dùng). */
export const ROLE_LABELS: Record<Role, string> = {
  get owner() { return i18n.t('common:roles.owner') },
  get admin() { return i18n.t('common:roles.admin') },
  get manager() { return i18n.t('common:roles.manager') },
  get member() { return i18n.t('common:roles.member') },
}

/** Biến avatarUrl tương đối (`/uploads/...`) thành URL tuyệt đối tới backend. */
export function avatarSrc(url?: string | null): string | undefined {
  if (!url) return undefined
  if (/^https?:\/\//.test(url)) return url
  return `${API_ORIGIN}${url}`
}

/** Các trường thông tin công ty lưu trong AppSetting (KV). `placeholder` là ví dụ minh hoạ — giữ tiếng Việt
 *  (địa chỉ/tên công ty mẫu theo quy ước VN) // i18n-ignore; `label` là getter đọc i18n lúc dùng. */
export const COMPANY_FIELDS: { key: string; label: string; placeholder: string; type?: string }[] = [
  { key: 'company.name', get label() { return i18n.t('settings:company.fields.name') }, placeholder: 'Công ty TNHH ABC' }, // i18n-ignore
  { key: 'company.phone', get label() { return i18n.t('settings:company.fields.phone') }, placeholder: '0900 000 000' },
  { key: 'company.email', get label() { return i18n.t('settings:company.fields.email') }, placeholder: 'contact@company.vn', type: 'email' },
  { key: 'company.website', get label() { return i18n.t('settings:company.fields.website') }, placeholder: 'https://company.vn' },
  { key: 'company.taxCode', get label() { return i18n.t('settings:company.fields.taxCode') }, placeholder: '0101234567' },
  { key: 'company.address', get label() { return i18n.t('settings:company.fields.address') }, placeholder: 'Số 1, Đường ABC, Quận 1, TP.HCM' }, // i18n-ignore
]

/** Nhãn nền tảng kênh giao tiếp — dùng chung bảng `lib/platform-labels` (khớp backend). */
export const PLATFORM_LABEL: Record<number, string> = PLATFORM_LABELS
